import React from 'react';

export type RenderProps = {
  message: string;
  title?: string;
  subtle?: boolean;
  hideIcon?: boolean;
};

const withInlineMessage = (
  message: string,
  subtle?: boolean,
  title?: string,
  hideIcon?: boolean
) => (Component: React.FunctionComponent<RenderProps>): React.FunctionComponent => (props: any) => (
  <Component {...props} message={message} title={title} subtle={subtle} hideIcon={hideIcon} />
);
export default withInlineMessage;
